import { GiftOutlined } from "@ant-design/icons";
import { Layout, Menu, Badge, Image } from "antd";
import { ArrowLeftIcon } from "components/svgs/ArrowLeftIcon";
import { ArrowRightIcon } from "components/svgs/ArrowRightIcon";
import { UserGroup } from "configs/constants";
import { selectGroup } from "modules/auth/store/authSlice";
import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import {
  ClientIcon,
  DashboardIcon,
  GroupIcon,
  OrderIcon,
  SettingIcon,
  HistoryIcon,
  InvoicingIcon,
  BroadcastIcon
} from "../../../components/svgs";
import "./AdminSiderContent.scss";
import { UserRole } from "configs/constants";
import { selectRole } from "modules/auth/store/authSlice";
import { Link } from "react-router-dom";
import UserInfo from "../Users/UserInfo";

const { Sider } = Layout;
const { SubMenu } = Menu;
const getPatchName = (str) => {
  let rs = "/admin";
  // Remove query parameters and trailing slash
  const pathWithoutQuery = str && str.split("?")[0];
  const path =
    pathWithoutQuery && pathWithoutQuery[pathWithoutQuery.length - 1] == "/"
      ? pathWithoutQuery.substring(0, pathWithoutQuery.length - 1)
      : pathWithoutQuery;
  switch (true) {
    case path === "/admin":
      rs = "/admin/dashboard";
      break;
    case path.includes("/admin") && path.includes("/scan2pack"):
      rs = "/admin/scan2pack";
      break;
    case path.includes("/admin") && path.includes("/plans"):
      rs = "/admin/plans";
      break;
    case path.includes("/admin") && path.includes("/saved-routes"):
      rs = "/admin/saved-routes";
      break;
    case path.includes("/admin") && path.includes("/dashboard/map"):
      rs = "/admin/dashboard/map";
      break;
    case path.includes("/admin") && path.includes("/dashboard/finance"):
      rs = "/admin/dashboard/finance";
      break;
    case path.includes("/admin") && path.includes("/dashboard"):
      rs = "/admin/dashboard";
      break;
    case path.includes("/admin") && path.includes("/users/clients"):
      rs = "/admin/users/clients";
      break;
    case path.includes("/admin") && path.includes("/users/territories"):
      rs = "/admin/users/territories";
      break;
    case path.includes("/admin") && path.includes("/users/admins"):
      rs = "/admin/users/admins";
      break;
    case path.includes("/admin") && path.includes("/users/drivers"):
      rs = "/admin/users/drivers";
      break;
    case path.includes("/admin") && path.includes("/clients"):
      rs = "/admin/clients";
      break;
    case path.includes("/admin") && path.includes("/settings/package-types"):
      rs = "/admin/settings/package-types";
      break;
    case path.includes("/admin") && path.includes("/settings/vehicle-categories"):
      rs = "/admin/settings/vehicle-categories";
      break;
    case path.includes("/admin") && path.includes("/settings/services"):
      rs = "/admin/settings/services";
      break;
    case path.includes("/admin") && path.includes("/settings/territories"):
      rs = "/admin/settings/territories";
      break;
    case path.includes("/admin") && path.includes("/routes"):
      rs = "/admin/routes";
      break;
    case path.includes("/admin") && path.includes("/history"):
      rs = "/admin/history";
      break;
    case path.includes("/admin") && path.includes("/invoicing"):
      rs = "/admin/invoicing";
      break;
    case path.includes("/admin") && path.includes("/facturas"):
      rs = "/admin/facturas";
      break;
    case path.includes("/admin") && path.includes("/billing-dashboard"):
      rs = "/admin/billing-dashboard";
      break;
    case path.includes("/admin") && path.includes("/billing/entitlements"):
      rs = "/admin/billing/entitlements";
      break;
    case path.includes("/admin") && path.includes("/billing/reports"):
      rs = "/admin/billing/reports";
      break;
    case path.includes("/admin") && path.includes("/billing/tiers"):
      rs = "/admin/billing/tiers";
      break;
    case path.includes("/admin") && path.includes("/settings/version"):
      rs = "/admin/settings/version";
      break;
    case path.includes("/admin") && path.includes("/pool/packages"):
      rs = "/admin/pool/packages";
      break;
    case path.includes("/admin") && path.includes("/pool/orders"):
      rs = "/admin/pool/orders";
      break;
    case path.includes("/admin") && path.includes("/reports"):
      rs = "/admin/reports";
      break;
    case path.includes("/admin") && path.includes("/locations"):
      rs = "/admin/locations";
      break;
    case path.includes("/admin") && path.includes("/delayed-routes"):
      rs = "/admin/delayed-routes";
      break;
    case path.includes("/admin") && path.includes("/pool/promo-codes"):
      rs = "/admin/pool/promo-codes";
      break;
    case path.includes("/admin") && path.includes("/settings/saas-countries"):
      rs = "/admin/settings/saas-countries";
      break;
    case path.includes("/admin") && path.includes("/settings/failed-registration"):
      rs = "/admin/settings/failed-registration";
      break;
    case path.includes("/admin") && path.includes("/driver-broadcasts"):
      rs = "/admin/driver-broadcasts";
      break;
    case path.includes("/admin") && path.includes("/pdf417-generator"):
      rs = "/admin/pdf417-generator";
      break;
    case path.includes("/admin") && path.includes("/ai-import"):
      rs = "/admin/ai-import";
      break;
  }
  return rs;
};

const AdminSiderContent = () => {
  const location = useLocation();
  const pathname = getPatchName(getPatchName(location.pathname));
  const [siderKey, setSiderKey] = useState(pathname);
  const [openKey, setOpenKey] = useState([]);
  const [collapsed, setCollapsed] = useState(false);
  const handleClickCollapse = useCallback(() => {
    setCollapsed((prev) => !prev);
  }, []);

  const role = useSelector(selectRole);
  const admin = useSelector((state) => state.auth.user);

  const history = useHistory();

  const isFlexioAdmin = useSelector(selectGroup) === UserGroup.FLEXIO;

  useEffect(() => {
    // Update siderKey when pathname changes (e.g., programmatic navigation)
    setSiderKey(pathname);

    if (pathname.includes("/users/")) {
      setOpenKey(["users"]);
    } else if (pathname.includes("/settings/")) {
      setOpenKey(["settings"]);
    } else if (pathname.includes("/pool/")) {
      setOpenKey(["pool"]);
    } else if (
      pathname.includes("/invoicing/") ||
      pathname.includes("/facturas") ||
      pathname.includes("/billing-dashboard") ||
      pathname.includes("/billing/entitlements") ||
      pathname.includes("/billing/reports") ||
      pathname.includes("/billing/tiers")
    ) {
      setOpenKey(["billing"]);
    } else if (
      pathname.includes("/dashboard") ||
      pathname === "/admin" ||
      pathname.includes("/delayed-routes") ||
      pathname.includes("/reports")
    ) {
      setOpenKey(["dashboard"]);
    } else if (
      pathname.includes("/routes") ||
      pathname.includes("/plans") ||
      pathname.includes("/scan2pack") ||
      pathname.includes("/saved-routes") ||
      pathname.includes("/pdf417-generator") ||
      pathname.includes("/ai-import")
    ) {
      setOpenKey(["routes-menu"]);
    }
  }, [pathname]);

  const handleClickMenuItem = (value) => {
    const key = value?.key;
    setSiderKey(getPatchName(key));

    // Close submenu when clicking submenu items in collapsed sidebar
    if (collapsed) {
      setOpenKey([]);
    }

    key && history.push(`${key}`);
  };

  const handleClickMenuSub = (value) => {
    // Special handling for billing submenu - navigate to billing dashboard
    if (value.key === "billing") {
      setSiderKey("/admin/billing-dashboard");
      history.push("/admin/billing-dashboard");
      // Still open the submenu
      const newOpenKeys = [...openKey];
      if (!newOpenKeys.includes(value.key)) {
        newOpenKeys.push(value.key);
        setOpenKey(newOpenKeys);
      }
      return;
    }

    // Special handling for dashboard submenu - navigate to operations
    if (value.key === "dashboard") {
      setSiderKey("/admin/dashboard");
      history.push("/admin/dashboard");
      // Still open the submenu
      const newOpenKeys = [...openKey];
      if (!newOpenKeys.includes(value.key)) {
        newOpenKeys.push(value.key);
        setOpenKey(newOpenKeys);
      }
      return;
    }

    // Special handling for routes-menu submenu - navigate to active routes
    if (value.key === "routes-menu") {
      setSiderKey("/admin/routes");
      history.push("/admin/routes");
      // Still open the submenu
      const newOpenKeys = [...openKey];
      if (!newOpenKeys.includes(value.key)) {
        newOpenKeys.push(value.key);
        setOpenKey(newOpenKeys);
      }
      return;
    }

    // Special handling for pool submenu - navigate to packages
    if (value.key === "pool") {
      setSiderKey("/admin/pool/packages");
      history.push("/admin/pool/packages");
      // Still open the submenu
      const newOpenKeys = [...openKey];
      if (!newOpenKeys.includes(value.key)) {
        newOpenKeys.push(value.key);
        setOpenKey(newOpenKeys);
      }
      return;
    }

    // Special handling for users submenu - navigate to clients
    if (value.key === "users") {
      setSiderKey("/admin/users/clients");
      history.push("/admin/users/clients");
      // Still open the submenu
      const newOpenKeys = [...openKey];
      if (!newOpenKeys.includes(value.key)) {
        newOpenKeys.push(value.key);
        setOpenKey(newOpenKeys);
      }
      return;
    }

    const newOpenKeys = [...openKey];
    if (newOpenKeys.includes(value.key)) {
      const index = newOpenKeys.findIndex((key) => key === value.key);
      newOpenKeys.splice(index, 1);
      setOpenKey(newOpenKeys);
    } else {
      newOpenKeys.push(value.key);
      setOpenKey(newOpenKeys);
    }
  };

  const handleMouseEnterSubMenu = useCallback(
    (value) => {
      if (collapsed) {
        setOpenKey((prev) => {
          if (!prev.includes(value.key)) {
            return [...prev, value.key];
          }
          return prev;
        });
      }
    },
    [collapsed]
  );

  const handleMouseLeaveSubMenu = useCallback(
    (value) => {
      if (collapsed) {
        setOpenKey((prev) => prev.filter((key) => key !== value.key));
      }
    },
    [collapsed]
  );
  return (
    <Sider
      className="admin-sider-content-component"
      trigger={null}
      collapsible
      width={220}
      collapsed={collapsed}
    >
      <div className="sidebar-header">
        <Link to="/admin">
          <Image
            src={`/logos/${window.REACT_APP_LOGO_FILE_NAME}`}
            alt="logo"
            preview={false}
            style={{
              width: collapsed ? "2rem" : "8rem",
              maxWidth: "100%",
              transition: "all 0.2s ease"
            }}
          />
        </Link>
      </div>
      <div className="sidebar-menu">
        <Menu
          mode="inline"
          openKeys={openKey}
          selectedKeys={[siderKey]}
          onClick={handleClickMenuItem}
        >
          <SubMenu
            key="dashboard"
            icon={
              <span className="anticon">
                <DashboardIcon />
              </span>
            }
            title="Dashboard"
            onTitleClick={handleClickMenuSub}
            onMouseEnter={() => handleMouseEnterSubMenu({ key: "dashboard" })}
            onMouseLeave={() => handleMouseLeaveSubMenu({ key: "dashboard" })}
          >
            <Menu.Item
              key="/admin/dashboard"
              icon={<span className="iconClass operation-icon"></span>}
            >
              Operations
            </Menu.Item>
            {/*<Menu.Item key="/admin/dashboard/finance">Finance</Menu.Item>*/}
            <Menu.Item
              key="/admin/dashboard/map"
              icon={<span className="iconClass mapIcon"></span>}
            >
              Map
            </Menu.Item>
            {window.ROUTES_DELAYED && (
              <Menu.Item
                key="/admin/delayed-routes"
                icon={<span className="iconClass clock-icon"></span>}
              >
                Dispatch Center
              </Menu.Item>
            )}
            <Menu.Item
              key="/admin/reports"
              icon={<span className="iconClass chart-icon"></span>}
            >
              Reports
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="routes-menu"
            icon={
              <span className="anticon">
                <OrderIcon />
              </span>
            }
            title="Active Routes"
            onTitleClick={handleClickMenuSub}
            onMouseEnter={() => handleMouseEnterSubMenu({ key: "routes-menu" })}
            onMouseLeave={() => handleMouseLeaveSubMenu({ key: "routes-menu" })}
          >
            <Menu.Item
              key="/admin/routes"
              icon={<span className="iconClass operation-icon"></span>}
            >
              Active Routes
            </Menu.Item>
            <Menu.Item
              key="/admin/plans"
              icon={<span className="iconClass operation-icon"></span>}
            >
              Plans
            </Menu.Item>
            <Menu.Item
              key="/admin/scan2pack"
              icon={<span className="iconClass packagesIcon"></span>}
            >
              Scan 2 Pack
            </Menu.Item>
            <Menu.Item
              key="/admin/saved-routes"
              icon={<span className="iconClass operation-icon"></span>}
            >
              Saved Routes
            </Menu.Item>
            <Menu.Item
              key="/admin/pdf417-generator"
              icon={<span className="iconClass packagesIcon"></span>}
            >
              PDF417 Gen
            </Menu.Item>
            <Menu.Item
              key="/admin/ai-import"
              icon={<span className="iconClass operation-icon"></span>}
            >
              AI Import
            </Menu.Item>
          </SubMenu>
          {/* pool */}
          <SubMenu
            key="pool"
            icon={
              <span className="anticon">
                <GiftOutlined />
              </span>
            }
            title="Flexio Pool"
            onTitleClick={handleClickMenuSub}
            onMouseEnter={() => handleMouseEnterSubMenu({ key: "pool" })}
            onMouseLeave={() => handleMouseLeaveSubMenu({ key: "pool" })}
          >
            <Menu.Item
              key="/admin/pool/packages"
              icon={<span className="iconClass packagesIcon"></span>}
            >
              Packages
            </Menu.Item>
            {window.POOL_ORDER_LIST && (
              <Menu.Item
                key="/admin/pool/orders"
                icon={<span className="iconClass mapIcon"></span>}
              >
                Orders
              </Menu.Item>
            )}
            <Menu.Item
              key="/admin/pool/promo-codes"
              icon={<span className="iconClass couponIcon"></span>}
            >
              Promo Codes
            </Menu.Item>
          </SubMenu>
          <SubMenu
            key="billing"
            icon={
              <span className="anticon">
                <InvoicingIcon />
              </span>
            }
            title="Billing"
            onTitleClick={handleClickMenuSub}
            onMouseEnter={() => handleMouseEnterSubMenu({ key: "billing" })}
            onMouseLeave={() => handleMouseLeaveSubMenu({ key: "billing" })}
          >
            <Menu.Item
              key="/admin/billing-dashboard"
              icon={<span className="iconClass chart-icon"></span>}
            >
              Dashboard
            </Menu.Item>
            <Menu.Item
              key="/admin/facturas"
              icon={<span className="iconClass operation-icon"></span>}
            >
              Invoices
            </Menu.Item>
            <Menu.Item
              key="/admin/billing/entitlements"
              icon={<span className="iconClass packagesIcon"></span>}
            >
              Entitlements
            </Menu.Item>
            <Menu.Item
              key="/admin/billing/tiers"
              icon={<span className="iconClass servicesIcon"></span>}
            >
              Tiers
            </Menu.Item>
            <Menu.Item
              key="/admin/billing/reports"
              icon={<span className="iconClass chart-icon"></span>}
            >
              Reports
            </Menu.Item>
          </SubMenu>
          <Menu.Item
            key="/admin/history"
            icon={
              <span className="anticon">
                <HistoryIcon />
              </span>
            }
          >
            History
          </Menu.Item>
          <Menu.Item
            key="/admin/clients"
            icon={
              <span className="anticon">
                <ClientIcon />
              </span>
            }
          >
            Companies
          </Menu.Item>
          {role === UserRole.ADMIN && (
            <SubMenu
              key="users"
              icon={
                <span className="anticon">
                  <GroupIcon />
                </span>
              }
              title="Users"
              onTitleClick={handleClickMenuSub}
              onMouseEnter={() => handleMouseEnterSubMenu({ key: "users" })}
              onMouseLeave={() => handleMouseLeaveSubMenu({ key: "users" })}
            >
              <Menu.Item
                key="/admin/users/clients"
                icon={<span className="iconClass clientIcon"></span>}
              >
                Client
              </Menu.Item>
              {isFlexioAdmin && (
                <Menu.Item
                  key="/admin/users/territories"
                  icon={<span className="iconClass territoryIcon"></span>}
                >
                  Territory
                </Menu.Item>
              )}
              <Menu.Item
                key="/admin/users/drivers"
                icon={<span className="iconClass driverClass"></span>}
              >
                Driver
              </Menu.Item>
              {isFlexioAdmin && (
                <Menu.Item
                  key="/admin/users/admins"
                  icon={<span className="iconClass adminClass"></span>}
                >
                  Admin
                </Menu.Item>
              )}
            </SubMenu>
          )}
          {isFlexioAdmin && role !== UserRole.VIEWER && (
            <>
              <SubMenu
                key="settings"
                icon={
                  <span className="anticon">
                    <SettingIcon />
                  </span>
                }
                title="Settings"
                onTitleClick={handleClickMenuSub}
                onMouseEnter={() => handleMouseEnterSubMenu({ key: "settings" })}
                onMouseLeave={() => handleMouseLeaveSubMenu({ key: "settings" })}
              >
                <Menu.Item
                  key="/admin/settings/saas-countries"
                  icon={<span className="iconClass countriesIcon"></span>}
                >
                  SAAS Countries
                </Menu.Item>
                <Menu.Item
                  key="/admin/settings/territories"
                  icon={<span className="iconClass territoryIcon"></span>}
                >
                  Territories
                </Menu.Item>
                <Menu.Item
                  key="/admin/settings/services"
                  icon={<span className="iconClass servicesIcon"></span>}
                >
                  Services
                </Menu.Item>
                <Menu.Item
                  key="/admin/settings/vehicle-categories"
                  icon={<span className="iconClass servicesIcon"></span>}
                >
                  Vehicle Categories
                </Menu.Item>
                <Menu.Item
                  key="/admin/settings/package-types"
                  icon={<span className="iconClass packagesIcon"></span>}
                >
                  Package Types
                </Menu.Item>
                <Menu.Item
                  key="/admin/settings/failed-registration"
                  icon={<span className="iconClass failedIcon"></span>}
                >
                  Failed Registration
                </Menu.Item>
                <Menu.Item
                  key="/admin/settings/version"
                  icon={<span className="iconClass territoryIcon"></span>}
                >
                  Version
                </Menu.Item>
              </SubMenu>
            </>
          )}
          <Menu.Item
            key="/admin/locations"
            icon={<span className="iconClass locationIcon"></span>}
          >
            Locations
          </Menu.Item>
          <Menu.Item
            key="/admin/driver-broadcasts"
            icon={
              <span className="anticon">
                <BroadcastIcon />
              </span>
            }
          >
            Driver Broadcast
          </Menu.Item>
        </Menu>
      </div>
      <div className="sidebar-footer">
        <UserInfo
          isUser={false}
          user={admin}
          hideInfo={collapsed}
          setHideInfo={() => setCollapsed(false)}
          isAdmin={true}
        />
      </div>
      <div className="button-collapse" onClick={handleClickCollapse}>
        <span>{collapsed ? <ArrowRightIcon /> : <ArrowLeftIcon />}</span>
      </div>
    </Sider>
  );
};
export default AdminSiderContent;
